import { useState, useEffect } from "react";
import "./message-box.css";
import ASSETS from "../../../app/config/assets";

const MessageBox = ({ type, msg }) => {
  const [icon, setIcon] = useState(ASSETS?.icon_info_png);

  useEffect(() => {
    if (type === "success") {
      setIcon(ASSETS?.icon_success_gif);
    } else if (type === "error") {
      setIcon(ASSETS?.icon_error_gif);
    } else if (type === "warning") {
      setIcon(ASSETS?.icon_alarm_gif);
    } else {
      setIcon(ASSETS?.icon_info_gif);
    }
  }, [type]);

  return (
    <div className={`w-full d-flex align-center p-md message-box ${type}`}>
      <img src={icon} alt="message box icon" />
      <span>{msg}</span>
    </div>
  );
};

export default MessageBox;
